/**
 * Icons im Feather-Stil, wie im Design-Prototyp: stroke-width 1.9–2.2,
 * abgerundete Enden, Größe über die Eigenschaft `groesse`.
 */

interface IconProps {
  groesse?: number;
  strich?: number;
  className?: string;
}

function Rahmen({
  groesse = 17,
  strich = 1.9,
  children,
  className,
}: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strich}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block' }}
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

/** Mein Tag – Sonne */
export const IconTag = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.5 1.5M16.9 16.9l1.5 1.5M18.4 5.6l-1.5 1.5M7.1 16.9l-1.5 1.5" />
  </Rahmen>
);

/** Kundenstammverwaltung – zwei Personen */
export const IconKunden = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="9.5" cy="8.5" r="3.3" />
    <path d="M3.5 20c0-3.2 2.7-5.5 6-5.5s6 2.3 6 5.5" />
    <path d="M16.5 6.4a3 3 0 0 1 0 5.6" />
    <path d="M18 20c0-2.4-.8-4.2-2-5.2" />
  </Rahmen>
);

/** Vertriebscockpit – Balken */
export const IconVertrieb = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M4 20V4" />
    <path d="M4 20h16" />
    <path d="M8 17v-5" />
    <path d="M13 17V8" />
    <path d="M18 17v-8" />
  </Rahmen>
);

/** Finanzen – Münze */
export const IconFinanzen = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="8.6" />
    <path d="M15.4 8.9a4 4 0 1 0 0 6.2" />
    <path d="M8.4 11.4h4.6M8.4 13.4h4.6" />
  </Rahmen>
);

/** Auftragsübersicht: unterschriebenes Dokument. */
export const IconAuftrag = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M6 3.4h7.6L18 7.8V20a.6.6 0 0 1-.6.6H6a.6.6 0 0 1-.6-.6V4a.6.6 0 0 1 .6-.6z" />
    <path d="M13.4 3.4v4.4H18" />
    <path d="M8.4 15.6c1.4-1.9 2.2-.4 3.2-1.4s1.4-2 2.2-1.1" />
  </Rahmen>
);

/** Sensibler Bereich */
export const IconSchloss = (p: IconProps) => (
  <Rahmen groesse={12} strich={2.2} {...p}>
    <rect x="4" y="10.5" width="16" height="10.5" rx="2.6" />
    <path d="M8 10.5V7.4a4 4 0 0 1 8 0v3.1" />
  </Rahmen>
);

export const IconProfil = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <circle cx="12" cy="8.5" r="3.6" />
    <path d="M5 20c0-3.4 3.1-5.8 7-5.8s7 2.4 7 5.8" />
  </Rahmen>
);

export const IconEinstellungen = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2 2 2 0 1 1-4 0 1.7 1.7 0 0 0-2.9-1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.7 1.7 0 0 0 3 15a2 2 0 1 1 0-4 1.7 1.7 0 0 0 1.2-2.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.7 1.7 0 0 0 10 4.1a2 2 0 1 1 4 0 1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1A1.7 1.7 0 0 0 21 11a2 2 0 1 1 0 4z" />
  </Rahmen>
);

export const IconAdmin = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M12 3l7.5 3v5.4c0 4.2-3 7.9-7.5 9.6-4.5-1.7-7.5-5.4-7.5-9.6V6z" />
    <path d="M9.4 12l1.9 1.9 3.4-3.6" />
  </Rahmen>
);

export const IconAbmelden = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M15 4h3.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H15" />
    <path d="M10 8l-4 4 4 4" />
    <path d="M6 12h9" />
  </Rahmen>
);

export const IconBurger = (p: IconProps) => (
  <Rahmen groesse={18} strich={2.1} {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Rahmen>
);

export const IconHaken = (p: IconProps) => (
  <Rahmen groesse={16} strich={2.2} {...p}>
    <path d="M5 12.5l4.5 4.5L19 7" />
  </Rahmen>
);

export const IconStift = (p: IconProps) => (
  <Rahmen groesse={14} {...p}>
    <path d="M4 20h4l10-10-4-4L4 16z" />
    <path d="M13.5 6.5l4 4" />
  </Rahmen>
);

export const IconSuche = (p: IconProps) => (
  <Rahmen groesse={16} {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M16 16l4 4" />
  </Rahmen>
);

export const IconTelefon = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M6.2 3.6h3l1.5 3.7-1.9 1.4a11.5 11.5 0 0 0 5.5 5.5l1.4-1.9 3.7 1.5v3a1.8 1.8 0 0 1-2 1.8A15.6 15.6 0 0 1 4.4 5.6a1.8 1.8 0 0 1 1.8-2z" />
  </Rahmen>
);

/** Papierflieger – „Angebot versendet". */
export const IconGesendet = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M20.5 3.5 10.8 13.2" />
    <path d="M20.5 3.5 14.3 20.5l-3.5-7.3-7.3-3.5z" />
  </Rahmen>
);

export const IconMail = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <rect x="3" y="5.5" width="18" height="13" rx="2.4" />
    <path d="M3.8 7l8.2 6 8.2-6" />
  </Rahmen>
);

export const IconInfo = (p: IconProps) => (
  <Rahmen groesse={15} strich={2} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.2" />
    <path d="M12 7.6v.1" />
  </Rahmen>
);

export const IconWarnung = (p: IconProps) => (
  <Rahmen groesse={16} strich={2} {...p}>
    <path d="M12 4.2 21 19.5H3z" />
    <path d="M12 10v4" />
    <path d="M12 16.8v.1" />
  </Rahmen>
);

export const IconPfeilLinks = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M14 6l-6 6 6 6" />
  </Rahmen>
);

export const IconPfeilRechts = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M10 6l6 6-6 6" />
  </Rahmen>
);

export const IconHochladen = (p: IconProps) => (
  <Rahmen groesse={18} {...p}>
    <path d="M12 16V5" />
    <path d="M8 8.6 12 4.6l4 4" />
    <path d="M4.5 15.5v2.6A1.9 1.9 0 0 0 6.4 20h11.2a1.9 1.9 0 0 0 1.9-1.9v-2.6" />
  </Rahmen>
);

export const IconMuell = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M4.5 6.5h15" />
    <path d="M9 6.5V5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 5v1.5" />
    <path d="M6.5 6.5 7.3 19a1.6 1.6 0 0 0 1.6 1.5h6.2a1.6 1.6 0 0 0 1.6-1.5l.8-12.5" />
  </Rahmen>
);

/** Monday-Marke: drei Balken in den Originalfarben. */
/** Verbesserungsvorschläge – Glühbirne */
export const IconGluehbirne = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M9.2 17.5h5.6" />
    <path d="M10 20.5h4" />
    <path d="M12 3.5a5.6 5.6 0 0 0-3.3 10.1c.5.4.8 1 .8 1.6v.3h5v-.3c0-.6.3-1.2.8-1.6A5.6 5.6 0 0 0 12 3.5Z" />
  </Rahmen>
);

/** Buchhaltungsvorbereitung – Beleg */
export const IconBeleg = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M5.5 3.5h13v17l-2.2-1.5-2.1 1.5-2.2-1.5-2.2 1.5-2.1-1.5-2.2 1.5Z" />
    <path d="M9 8h6" />
    <path d="M9 12h6" />
  </Rahmen>
);

export function IconMonday({ groesse = 15 }: { groesse?: number }) {
  return (
    <svg width={groesse} height={groesse} viewBox="0 0 24 24" aria-hidden="true" style={{ display: 'block' }}>
      <rect x="2.5" y="4" width="4.6" height="16" rx="2.3" fill="#E2445C" />
      <rect x="9.7" y="4" width="4.6" height="16" rx="2.3" fill="#FFCB00" />
      <rect x="16.9" y="4" width="4.6" height="16" rx="2.3" fill="#00CA72" />
    </svg>
  );
}

/** SharePoint-Marker im Markenton. */
export function IconSharepoint({ groesse = 15 }: { groesse?: number }) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: groesse,
        height: groesse,
        borderRadius: 4,
        background: '#036C70',
        color: '#FFFFFF',
        fontSize: Math.round(groesse * 0.67),
        fontWeight: 700,
        lineHeight: `${groesse}px`,
        textAlign: 'center',
        display: 'block',
      }}
    >
      S
    </span>
  );
}

/**
 * Ordner – für den Link, der die Ablage im Explorer öffnet.
 *
 * Bewusst einfarbig und in der Textfarbe: Der Link soll als Link erkennbar
 * sein, nicht als Schaltfläche. Monday darf farbig bleiben, weil dort die
 * Marke wiedererkannt werden soll.
 */
export function IconOrdner({ groesse = 15 }: { groesse?: number }) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block' }}
    >
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </svg>
  );
}
